module.exports = __webpack_public_path__ + "static/media/arrowDown.5369dbf2.svg";